[
  {
    "id":"pbm_order_id",
    "label":"Order Id",
    "enable": true,
    "sort":"route_state",
    "order":1,
    "width": "110px"
  },
  {
    "id":"route_name",
    "label":"Route",
    "enable": true,
    "sort":"route_state",
    "order":2,
    "width": "88px"
  },
  {
    "id":"bl_name",
    "label":"BLOM Location",
    "enable": true,
    "sort":"route_state",
    "order":3,
    "width": "130px"
  },
  {
    "id":"stop_sequence",
    "label":"Stop",
    "enable": true,
    "sort":"route_state",
    "order":4,
    "width": "50px"
  },
  {
    "id":"task_sequence",
    "label":"Task",
    "enable": true,
    "sort":"route_state",
    "order":5,
    "width": "50px"
  },
  {
    "id":"task_point_name",
    "label":"Task Point Name",
    "enable": true,
    "sort":"route_state",
    "order":6,
    "width": "135px"
  },
  {
    "id":"address",
    "label":"Address",
    "enable": true,
    "sort":"route_state",
    "order":7,
    "width": "82px"
  },
  {
    "id":"postal_code",
    "label":"Postal Code",
    "enable": true,
    "sort":"route_state",
    "order":8,
    "width": "113px"
  },
  {
    "id":"delivery_point_area_name",
    "label":"DLA",
    "enable": true,
    "sort":"route_state",
    "order":9,
    "width": "69px"
  },
  {
    "id":"pn_item_id",
    "label":"Barcode",
    "enable": true,
    "sort":"route_state",
    "order":10,
    "width": "90px"
  },
  {
    "id":"consignee_name",
    "label":"Consignee Name",
    "enable": true,
    "sort":"route_state",
    "order":11,
    "width": "140px"
  },
  {
    "id":"outside_sp_perimeter",
    "label":"Perimeter",
    "enable": true,
    "sort":"route_state",
    "order":12,
    "width": "75px"
  },
  {
    "id":"item_count",
    "label":"Items",
    "enable": true,
    "sort":"route_state",
    "order":13,
    "width": "65px"
  },
  {
    "id":"goods_count",
    "label":"Goods",
    "enable": true,
    "sort":"route_state",
    "order":14,
    "width": "77px"
  },
  {
    "id":"quantity",
    "label":"Quantity",
    "enable": true,
    "sort":"route_state",
    "order":15,
    "width": "92px"
  },
  {
    "id":"reason_code",
    "label":"Reason Code",
    "enable": true,
    "sort":"route_state",
    "order":16,
    "width": "115px"
  },
   {
    "id":"user_name",
    "label":"User Information",
    "enable": true,
    "sort":"route_state",
    "order":17,
    "width": "149px"
  },
   {
    "id":"driver_instruction",
    "label":"Driver Note",
    "enable": true,
    "sort":"route_state",
    "order":18,
    "width": "111px"
  },
  {
    "id":"manager_instruction",
    "label":"Manager Note",
    "enable": true,
    "sort":"route_state",
    "order":19,
    "width": "123px"
  },
  {
    "id":"vehicle_type",
    "label":"Vehicle Type",
    "enable": true,
    "sort":"route_state",
    "order":20,
    "width": "100px"
  },
  {
    "id":"task_type",
    "label":"Type",
    "enable": true,
    "sort":"route_state",
    "order":21,
    "width": "73px"
  },
  {
    "id":"item_state",
    "label":"Item State",
    "enable": true,
    "sort":"route_state",
    "order":22,
    "width": "80px"
  },
  {
    "id":"source",
    "label":"Source",
    "enable": true,
    "sort":"route_state",
    "order":23,
    "width": "78px"
  },
  {
    "id":"initial_eta",
    "label":"IETA",
    "enable": true,
    "sort":"route_state",
    "order":24,
    "width": "50px"
  },
  {
    "id":"eta",
    "label":"RETA",
    "enable": true,
    "sort":"route_state",
    "order":25,
    "width": "50px"
  },
  {
    "id":"ata",
    "label":"ATA",
    "enable": true,
    "sort":"route_state",
    "order":26,
    "width": "46px"
  },
  {
    "id":"task_time_window",
    "label":"Time Window",
    "enable": true,
    "sort":"route_state",
    "order":27,
    "width": "127px"
  },
  {
    "id":"task_state",
    "label":"Status",
    "enable": true,
    "sort":"route_state",
    "order":28,
    "width": "80px"
  },
  {
    "id":"weight",
    "label":"Weight",
    "enable": true,
    "sort":"route_state",
    "order":29,
    "width": "83px"
  },
  {
    "id":"volume",
    "label":"Volume",
    "enable": true,
    "sort":"route_state",
    "order":30,
    "width": "91px"
  },
  {
    "id":"product_codes",
    "label":"Product Codes",
    "enable": true,
    "sort":"route_state",
    "order":31,
    "width": "125px"
  }
]